import { Injectable } from '@angular/core';
import { NgbDatepickerConfig, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

// import { constants } from '../_shared/constants/constants.component';

import { TranslateService } from '@ngx-translate/core';
import { constants } from './constants';

const I18N_VALUES = {
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  },
  'th': {
    weekdays: ['จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส', 'อา'],
    months: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ษ.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
  },
};

const YEAR_RANGE = {
  'en': [1900, 2099],
  'th': [1900, 2099]
};

// Define a service holding the language. You probably already have one if your app is i18ned.
@Injectable()
export class I18n {
  language = constants.language;

  getAdjustYear(): number {
    if (this.language === 'th') {
      return 543;
    }
    return 0;
  }
}

// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(
    private _i18n: I18n, 
    config: NgbDatepickerConfig,
    private translate: TranslateService
  ) {
    super();

    // First day of week
    config.firstDayOfWeek = 7;

    // customize default values of datepickers used by this component tree
    config.minDate = { year: this.getMinYear(), month: 1, day: 1 };
    config.maxDate = { year: this.getMaxYear(), month: 12, day: 31 };

    // days that don't belong to current month are not visible
    config.outsideDays = 'hidden';

    // To disabled weekends
    config.markDisabled = (date: NgbDateStruct) => {
      const d = new Date(date.year, date.month - 1, date.day);
      // return d.getDay() === 0 || d.getDay() === 6;
      return false;
    };
  }

  getMaxYear(): number {
    return YEAR_RANGE[this.translate.currentLang][1];
  }

  getMinYear(): number {
    return YEAR_RANGE[this.translate.currentLang][0];
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this.translate.currentLang].weekdays[weekday - 1];
  }

  getMonthShortName(month: number): string {
    return I18N_VALUES[this.translate.currentLang].months[month - 1];
  }

  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return '';
  }

}
